import { makeId } from '@/utils/makeId'

export type Weight = {
  id: string
  multiplication_factor: number
  value: string
  description: string
}

export const weights: Weight[] = [
  {
    id: makeId(),
    multiplication_factor: 0.5,
    value: '500g',
    description: '5 fatias',
  },
  {
    id: makeId(),
    multiplication_factor: 1,
    value: '1kg',
    description: '10 fatias',
  },
  {
    id: makeId(),
    multiplication_factor: 2,
    value: '2kg',
    description: '20 fatias',
  },
  {
    id: makeId(),
    multiplication_factor: 3,
    value: '3kg',
    description: '30 fatias',
  },
  {
    id: makeId(),
    multiplication_factor: 4,
    value: '4kg',
    description: '40 fatias',
  },
  {
    id: makeId(),
    multiplication_factor: 5,
    value: '5kg',
    description: '50 fatias',
  },
]
